import Vue from 'vue';
import Vuex from 'vuex';
import { Notification } from 'element-ui';
import util from '../util.js';

Vue.use(Vuex);
//  应用程序状态    state
//  前端程序数据源，不可直接改变，只能通过已注册的mutations来改变数据，同时也只能通过已注册的getters 获取数据
//  命名规则：驼峰（实体名）
//  --尽量以Object，Array类型为主
let appKey=util.appKey();
let systemInfo = util.systemInfo();
const state = {
    jumpUrl:"",
    //----------------------sessionStorage ---------------------------------
    //sessionStorage 中存放的 user 信息 【login,home,】
    sessionUser:JSON.parse(window.sessionStorage.getItem(appKey)),
    systemInfo:JSON.parse(window.localStorage.getItem(systemInfo)),
    //sessionStorage 中存放的 菜单 信息 【menu】
    menuList:[],

    showEleLoading:false,  // 显示加载动画
    showSmallEleLoading:false,  // 显示弹出层查询表格加载动画
    operationButton:[],  //  eltable操作按钮 集合
    smallQueryAddParamByParent:{}, //父组件为smallQuery查询时预设置的查询参数

    mainBarCodeGoodsData:{}, //B00005模块根据条码检索到的基础资料信息
    goodsCategory: {},//所有商品分类信息
    goodsPicture: {},//B0005模块根据条码获取图片信息
    sysParamsInfo: [],//a00003模块，系统参数信息获取

    //----------------------报表 ---------------------------------
    queryName:"",
    queryParams:{},
    queryParamConfigData:{},
    chartSetting:[],
    autoExec:0,
    queryData:{
        data:{
            errors: {},
            isValid: false,
            dataList: [],
            dictionary:{},
            hideFields:''
        },
        totalCount:0,
    },
    pageObject:{
        currentPage:1,
        pageSize:10,
    },
    //弹出框
    smallQueryName:"",
    smallqueryParams:{},
    smallQueryConfigData:{},
    smallQueryTotalCount:0,
    smallQueryData:{
      data: {
        errors: {},
        isValid: false,
        dataList: [],
        dictionary: {},
        hideFields: '',
        isTree: false
      },
      totalCount:0,
    },
    //弹出框业务类型  *1.ReturnSelect  单个传值：配合data-Tag标记返回值  *2.SingleSelect  单行修改：egrid修改行数据 *3.MultiSelect   多行修改：egrid修改行数据
    smallQueryType:"",
    //
    SmallQueryHideParam:{},
    //----------------------模块 ---------------------------------
    //模块配置数据
    moduleConfigData:{
        SmartLookup:{},
        dataObjectData:{},
        iniConfig:{},
        queryParams:[],
        stdQueryChecks:[],
        isValid:false,
        chartType:"",
        queryName:"",
        objectFileds:[],
        BusinessPowIDList:{},
        objectNameParams:[],
        moduleID:"",
        chartSetting:[],
        autoExec:0
    },
    dataListCopy:{},
    //模块数据
    //当前审核步骤
    auditStep:0,
    //模块4种状态：None(未进入)，Normal（默认），Add，Modify
    ModuleState:"None",
    //业务标记
    BusPowID:"",
    //弹出框的回显值
    smallQueryReturnVal:"",
    //模块回显的数据
    DataObject:{
        errors: {},
        isValid: false,
        dataList: [],
        dictionary:{},
        disableList:[],
        updateFlag:[],
        isTree:false
    },
    //当前Grid Tab编号
	  TabId_Now:1,
    // dataObject 参数  带值
    dataObjectParams:{},
    // 业务执行结果
    bizQueryBatchData:{},

    //报表模块初始化data
    stdQueryConfigData:{},
    //报表查询参数
    reportQueryParamsData:{},

    //----------------- 卡券系统 ---------------------------------
    //
    specModule:{
        "F10001":"coupon-type" ,
        "F10002":"coupon-make",
        "F20001":"coupon-pre-detail",
        "F30001":"coupon-cancel"
    },
    activeTab:window.sessionStorage.getItem("activeTab"),
    SessionTabList:(window.sessionStorage.getItem("SessionTabList")?JSON.parse(window.sessionStorage.getItem("SessionTabList")):[]),
    echarsTheme:'macarons',
    //api
    tableData: '',
};

//  应用程序状态变化  mutations
//  前端程序数据源，不可直接改变，只能通过已注册的mutations来改变数据，同时也只能通过已注册的getters 获取数据
//  命名规则：常量命名（大写实体名+下划线_+大写动作名）
//  --每个mutation必须令数据同步变化，禁止在一个mutation中进行异步操作
const mutations = {
     //----------------- 卡券系统 ---------------------------------
    activeTabUpdate(state,tabID){
        state.activeTab=tabID;
        window.sessionStorage.setItem("activeTab",tabID)
    },
    addSessionTab(state,tabLink,tabID, tabName){
        if(state.SessionTabList.find(x=>{return x.tabID==tabID}) == undefined ){
            if(state.SessionTabList.length>=5){
                state.SessionTabList.splice(0,1);
            }
             let tab={ tabLink:tabLink,tabID:tabID, tabName:tabName};
            state.SessionTabList.push(tab);
             window.sessionStorage.setItem("SessionTabList",JSON.stringify(state.SessionTabList))
        }
        state.activeTab=tabID;
        window.sessionStorage.setItem("activeTab",tabID)

    },
    removeSessionTab(state,tabID){
        let idx=state.SessionTabList.findIndex(x=>{return x.tabID==tabID});
        state.SessionTabList.splice(idx,1);
         window.sessionStorage.setItem("SessionTabList",JSON.stringify(state.SessionTabList));
         if(tabID==state.activeTab){
            state.activeTab=(state.SessionTabList.length==0)?"":(state.SessionTabList[idx-1]?state.SessionTabList[idx-1].tabID:"");
            window.sessionStorage.setItem("activeTab",state.activeTab)
         }
    },
    removeAllSessionTab(state){
        state.SessionTabList.splice(0,state.SessionTabList.length);
        window.sessionStorage.setItem("SessionTabList",JSON.stringify(state.SessionTabList));
        state.activeTab="";
        window.sessionStorage.setItem("activeTab",state.activeTab)
    },
    //----------------1. 菜单--menuList--------------------
    // 1.1 更新菜单信息（优先从sessionStorage中获取）
    MENULIST_INIT(state,func){
       //console.log("欢迎您："+userId);
        //菜单数据缓存到sessionStorage
        if(window.sessionStorage&&sessionStorage.getItem("MenuList") ){
           var menu=sessionStorage.getItem("MenuList");
            state.menuList=JSON.parse(menu);
            console.log("从sessionStorage 获取菜单信息成功！")
            if(func)  func();
        }else{
            util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQuery",
                dataType:"json",
                data:{
                    "UserID":state.sessionUser?state.sessionUser.userId:"",
                    "queryName":"Menus",
                },
                success(data){
                    state.menuList=data.data.dataList
                    sessionStorage.setItem("MenuList",JSON.stringify(state.menuList));
                   //console.log("从接口 获取菜单信息成功！")
                },
                error(){
                    sessionStorage.removeItem("MenuList");
                }
            },func)
        }
    },

    //-----------------2. 登录用户--sessionUser---------------------
    // 2.1 登录
    SESSIONUSER_LOGIN(state,user,func){
        state.sessionUser=user;
        window.sessionStorage.setItem(appKey,JSON.stringify(state.sessionUser));
        /*
        if(window.sessionStorage.getItem("jumpUrl")!=null){
           let jumpUrl=window.sessionStorage.getItem("jumpUrl");
           window.sessionStorage.removeItem("jumpUrl")
           window.router.replace({path:jumpUrl});
         }else{
            window.router.replace({name:"home"});
         }
         */
    },
    // 2.2 注销
    SESSIONUSER_LOGOUT(state,func){
      //清除用戶信息
      if(state.sessionUser)
        state.sessionUser=undefined;
      //清除session
      if(sessionStorage.getItem(appKey))
        sessionStorage.removeItem(appKey);

      //清除MenuList
      if(sessionStorage.getItem("MenuList"))
        sessionStorage.removeItem("MenuList");

      //if(sessionStorage.getItem("systemInfo"))
      //  sessionStorage.removeItem("systemInfo");

      router.push({ path: '/login' });
      //this.$router.push({ path: '/login' });
		  // window.router.go({name:"login"});
    },

    //-----------------3.報表--stdQuery---------------------
    // 3.1 queryName
    QUERYNAME_UPDATE(state,qn){
        state.queryName=qn;
    },
    // 3.2.1 queryParams
    QUERYPARAMS_UPDATE(state,queryParams){
        state.queryParams=queryParams;
    },
    //3.2.2 queryParamConfig
    //用于根据moduleID取首页查询配置
    queryParamConfig_UPDATE(state,moduleID,func){
        util.myAjax({
            url:util.getUrl()+"/StdQuery/StdQueryConfig",
            data:{
                moduleID:moduleID
            },
            dataType:"json",
            success (d) {
                //console.log(JSON.stringify(d));
                if(d.isValid){
                    if(d.data.isValid){
                        state.queryParamConfigData=d.data;
                        for(let i=0;i<state.queryParamConfigData.queryParams.length;i++){
                            let  queryParam = state.queryParamConfigData.queryParams[i];
                            if(queryParam.paramname == "Operator" || queryParam.paramname == "OperName"){
                                state.queryParamConfigData.queryParams.splice($.inArray(queryParam,state.queryParamConfigData.queryParams),1);
                            }
                        };
                       //console.log(JSON.stringify(state.queryParamConfigData.chartSetting));
                        //更新queryName
                       state.queryName=state.queryParamConfigData.queryName;
                       //取autoExec值
                       state.autoExec=state.queryParamConfigData.autoExec;
                    }else{
                       Notification(util.eleErrorJson('查询参数异常'));
                    }
                }else{
                  var errors = d.errors;
                  if(errors.hasOwnProperty('errorMsg')){
                    var errorMsg=errors['errorMsg'];
                    Notification(util.eleErrorJson(errorMsg));
                  }else{
                    Notification(util.eleErrorJson('查询参数请求异常'));
                  }
                }
            },
            error(){
                Notification(util.eleErrorJson('查询参数请求出错'));
            }
        },func)
    },
    //用于根据queryName取首页查询配置
    queryParamConfig_UPDATE2(state,queryName,func){
      util.myAjax({
        url:util.getUrl()+"/StdQuery/StdQueryConfigByQueryName",
        data:{
          queryName:queryName
        },
        dataType:"json",
        success (d) {
          //console.log(JSON.stringify(d));
          if(d.isValid){
            if(d.data.isValid){
              state.queryParamConfigData=d.data;
              for(let i=0;i<state.queryParamConfigData.queryParams.length;i++){
                let  queryParam = state.queryParamConfigData.queryParams[i];
                if(queryParam.paramname == "Operator" || queryParam.paramname == "OperName"){
                  state.queryParamConfigData.queryParams.splice($.inArray(queryParam,state.queryParamConfigData.queryParams),1);
                }
              };
              //console.log(JSON.stringify(state.queryParamConfigData.chartSetting));
              //更新queryName
              state.queryName=state.queryParamConfigData.queryName;
              //取autoExec值
              state.autoExec=state.queryParamConfigData.autoExec;
            }else{
              Notification(util.eleErrorJson('查询参数异常'));
            }
          }else{
            var errors = d.errors;
            if(errors.hasOwnProperty('errorMsg')){
              var errorMsg=errors['errorMsg'];
              Notification(util.eleErrorJson(errorMsg));
            }else{
              Notification(util.eleErrorJson('查询参数请求异常'));
            }
          }
        },
        error(){
          Notification(util.eleErrorJson('查询参数请求出错'));
        }
      },func)
    },
    // 3.3 queryData
    QUERYDATA_UPDATE(state,curPage,pageSize,noReset,func){
            $("#eltable").find("div.table-responsive1").scrollLeft(0);
            /*let asyncBoolean = true;
            if(state.queryParams.hasOwnProperty('async')){
              asyncBoolean = state.queryParams['async'];
              delete state.queryParams['async'];
            }*/
            if(noReset !== true){
                state.queryData.data.dataList= [];
            }
            state.queryParams['currentPage']=curPage;
            state.queryParams['pageSize']=pageSize;
            let _self=this;
            util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQuery",
                data:state.queryParams,
                dataType:"json",
                /*async:asyncBoolean,*/
                beforeSend(){
                    state.showEleLoading = true; //开启
                },
                complete(){
                    state.showEleLoading = false;  //关闭
                },
                success(data) {
                    if(data.isValid){
                        if(data.data.isValid){
                            if(data.data.dataList.length>0){
                                    state.queryData=data;
                            }else{
                                Notification(util.eleInfoJson('暂未查询到数据'));
                                state.queryData.data={
                                        errors: {},
                                        isValid: false,
                                        dataList: [],
                                        dictionary:{},
                                        hideFields:''
                                };
                                state.queryData.totalCount=0;
                            }
                        }else{
                            var errors = data.data.errors;
                            if(errors.length>0){
                                var errorMsg = "";
                                for(var i= 0;i<errors.length;i++){
                                    var error = errors[i];
                                    errorMsg +=error.errorMsg;
                                }
                                Notification(util.eleErrorJson(errorMsg));
                            }else{
                               Notification(util.eleErrorJson('查询结果异常'));
                            }
                        }
                    }else{
                        Notification(util.eleErrorJson('查询结果请求异常'));
                    }

                },
                error(){
                    Notification(util.eleErrorJson('查询结果请求出错'));
                }
            },func)
    },
    // 3.4 queryData_Reset
    QUERYDATA_RESET(state){
        state.queryData.data={
                        errors: {},
                        isValid: false,
                        dataList: [],
                        dictionary:{},
                        hideFields:''
                };
        state.queryData.totalCount=0;
    },
    // 3.5 smallQueryConfigData
    SMALLQUERYCONFIGDATA_UPDATE(state,sql,func){
        util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQueryByName",
                dataType:"json",
                data:{
                    queryName:sql
                },
                success:function(data){
                    if(data&&data.isValid){
                        //console.log(JSON.stringify(data));
                        state.smallQueryConfigData = data.data;
                        //console.log(JSON.stringify(state.smallQueryConfigData));
                        state.smallQueryName=data.data.queryName;
                    }else{
                         state.smallQueryConfigData ={};
                        state.smallQueryName="";
                    }
                }
        },func)
    },
     // 3.5.2 smallQueryConfigData
    SMALLQUERYCONFIGDATA_RESET(state){
        state.smallQueryConfigData ={};
        state.smallQueryName="";
    },
  //3.5.3 queryParamConfigData 重置
      QUERYPARAMCONFIGDATA_RESET(state){
       // console.log('重置  queryConfigDataReset')
        state.queryParamConfigData = {};
       },

    // 3.6 smallQueryTotalCount
    SMALLQUERYTOTALCOUNT_UPDATE(state,totalCount){
        state.smallQueryTotalCount=totalCount;
    },
    //
    SMALLQUERYPARAMS_UPDATE(state,queryParams){
      state.smallqueryParams=queryParams;
    },
    // 3.7 smallQueryData
    SMALLQUERYDATA_UPDATE(state,curPage,pageSize,func){
       state.smallqueryParams['currentPage']=curPage;
       state.smallqueryParams['pageSize']=pageSize;
       util.myAjax({
                    url:util.getUrl()+"/StdQuery/StdQuery",
                    data:state.smallqueryParams,
                    dataType:"json",
                    beforeSend(){
                      state.showSmallEleLoading = true; //开启
                    },
                    complete(){
                      state.showSmallEleLoading = false;  //关闭
                    },
                    success:function(data){
                        if(data.isValid){
                			if(data.data.isValid){
                				 if(data.data.dataList.length>0){
                                  state.smallQueryData=data;
                           //把价格字段设置成保留2位小数
                           if(state.smallQueryData.data.dataList.length){
                             for(let i=0; i<state.smallQueryData.data.dataList.length; i++){
                               for(var key in state.smallQueryData.data.dataList[i]){
                                 if(key.indexOf('Price')!=-1){
                                   state.smallQueryData.data.dataList[i][key] = state.smallQueryData.data.dataList[i][key].toFixed(2);
                                 }
                               }
                             }
                           }
                                  state.smallQueryTotalCount=data.totalCount;
                                }else{
                                   Notification(util.eleInfoJson('暂未查询到数据'));
                                  state.smallQueryData.data={
                                                 errors: {},
                                                  isValid: false,
                                                  dataList: [],
                                                  dictionary:{},
                                                  hideFields:'',
                                                  isTree:false,
                                          };
                                          state.smallQueryData.totalCount=0;
                                          state.smallQueryTotalCount=0;
                                      }
                			}else{
                				var errors = data.data.errors;
                    			if(errors.length>0){
                    				var errorMsg = "";
                    				for(var i= 0;i<errors.length;i++){
                    					var error = errors[i];
                    					errorMsg +=error.errorMsg;
                    				}
                            Notification(util.eleErrorJson(errorMsg));
                    			}else{
                            Notification(util.eleErrorJson('弹出框查询结果异常'));
                    			}
                			}
                		}else{
                        Notification(util.eleErrorJson('弹出框查询结果请求异常'));
                		}
                    }
            },func)
    },
    //3.8 smallQueryData_Reset
    SMALLQUERYDATA_RESET(state){
        state.smallQueryData.data={
                        errors: {},
                        isValid: false,
                        dataList: [],
                        dictionary:{},
                        hideFields:'',
                        isTree:false
                };
        state.smallQueryData.totalCount=0;
        state.smallQueryTotalCount=0;
    },
     // 3.9 smallQueryReturnVal_update
    SMALLQUERYRETURNVAL_UPDATE(state,returnVal){
        state.smallQueryReturnVal=returnVal;
    },
    //3.10 smallQueryType  枚举
    SmallQueryType_UPDATE(state,type){
        state.smallQueryType=type;
    },
    //3.11 SmallQueryHideParam 弹出框隐藏参数
     SmallQueryHideParam_UPDATE(state,hideParam){
         state.SmallQueryHideParam=hideParam;
     },
     //3.12
     pageObject_UPDATE(state,pageObj){
         state.pageObject=pageObj;
     },
    //-----------------4.模块--stdModule---------------------
    //4.1 模块配置数据
    MODULECONFIGDATA_UPDATE(state,moduleID){
        util.myAjax({
                url:util.getUrl()+"/StdQuery/moduleConfig",
                dataType:"json",
                data:{
                    moduleID:moduleID,
                },
                success:function(data){
                    if(data&&data.isValid){
                        state.moduleConfigData = data.data;
                       //console.log("模块数据加载成功！")
                    }else{
                        state.moduleConfigData={
                            SmartLookup:{},
                            dataObjectData:{},
                            iniConfig:{},
                            queryParams:[],
                            stdQueryChecks:[],
                            isValid:false,
                            chartType:"",
                            queryName:"",
                            objectFileds:[],
                            BusinessPowIDList:{},
                            objectNameParams:[],
                            moduleID:"",
                            chartSetting:[],
                            autoExec:0
                        };
                    }
                }
            });
    },
    //4.1.1 清空DataList
    DataList_RESET(state){
        let datalist=state.moduleConfigData.dataObjectData.dataList
        Object.keys( datalist).forEach(x=>{
            if(x.split("_")[1]>0){
                datalist[x].splice(1);                                  //保留一个空对象
                let dataobj=datalist[x][0];
                Object.keys(dataobj).forEach(y=>{       //清空属性值
                    dataobj[y]="";
                });
            }
        });
    },
     //4.2 当前审核步骤 auditStep
    AUDITSTEP_UPDATE(state,auditStep){
        state.auditStep=auditStep;
    },
     //4.3 模块4种状态：Normal（默认），Add，Modify，Del
    MODULESTATE_UPDATE(state,moduleState){
       //console.log("moduleState=="+moduleState)
        state.ModuleState=moduleState
    },
    //4.4 业务标记
    BusPowID_UPDATE(state,Business){
        state.BusPowID=Business;
    },
    //4.5.1 单据详情 Ajax 更新数据
    DataObject_UPDATE(state,param,func){
        let asyncBoolean = true;
        if(param.hasOwnProperty('async')){
           asyncBoolean = param['async'];
           delete param['async'];
        }
        util.myAjax({
                url:util.getUrl()+"/dataObject/dataObject",
                dataType:"json",
                data:param,
                async:asyncBoolean,
                 beforeSend: function(){
                    util.showLoading();
                },
                complete: function(){
                    util.removeLoading();
                },
                success:function(data){
                    if(data&&data.isValid==true){
                        //设置审核步骤
                         state.auditStep
                         let obj=data.data.dataList.dataList_0[0];
                         Object.keys(obj).forEach(x=>{
                             if(x.includes("Checked_")){
                                 if(obj[x]==true){
                                     state.auditStep=x.split("_")[1];
                                 }
                             }else if(x.includes("Checked")&&obj[x]==true){
                                 state.auditStep=Object.keys(obj).filter(y=>{return y.includes("Checked")}).length;
                             }
                         });

                        state.DataObject=data.data;
                        let arr={};
                        let arr2={};
                        Object.keys(data.data.dataList).forEach((x,i)=>{
                            if(i>0){
                                let disableArr=[];
                                let updateFlag=[];
                                let filedArr=data.data.dataList["dataList_"+i];
                                //禁用标识
                                filedArr.forEach(y=>{
                                    disableArr.push(false);
                                    updateFlag.push("N");

                                });
                                arr["disableList_"+i]=disableArr;
                                arr2["updateFlag_"+i]=updateFlag;
                            }
                        });
                        state.DataObject= Object.assign({},state.DataObject,{"disableList":arr},{"updateFlag":arr2});
                    }else{
                        Notification(util.eleErrorJson('单据查询异常'));
                        state.DataObject={
                            errors: {},
                            isValid: false,
                            dataList: [],
                            dictionary:{},
                            disableList:[],
                            updateFlag:[],
                            isTree:false
                        };
                    }
                }
        },func)
    },
    //4.5.2 单据详情 赋值 更新数据 : data:数据，name:要修改的属性名
    DataObject_MODIFY(state,data,name){
        state.DataObject[name]=data;
    },
    //4.5.3 单据详情 重置
    DataObject_RESET(state){
        state.DataObject={
            errors: {},
            isValid: false,
            dataList: [],
            dictionary:{},
            disableList:[],
            isTree:false
        };
    },
    //4.5.4 设置dataObjecParams的参数
    DataObject_PARAMS(state,param){
        state.dataObjectParams=param;
    },
    //4.6 Grid 明细编号
    TabId_Now_UPDATE(state,id){
        state.TabId_Now=id;
    },
    //4.7  业务操作
    BizQueryBatch_EXECUTE(state,param,func){
        //console.log(state.ModuleState+" 操作的JSON :"+JSON.stringify(param));
        let asyncBoolean = true;
        if(param.hasOwnProperty('async')){
            asyncBoolean = param['async'];
            delete param['async'];
        }
        let showErrorMsg = true;   //显示错误弹框
        if(param.hasOwnProperty('showErrorMsg')){
          showErrorMsg = param['showErrorMsg'];
          delete param['showErrorMsg'];
        }
        util.myAjax({
                url:util.getUrl()+"/BizQuery/BizQueryBatch",
                dataType:"json",
                async:asyncBoolean,
                data:{
                    data:JSON.stringify(param)
                },
                 beforeSend: function(){
                    util.showLoading();
                    state.bizQueryBatchData={};
                },
                complete: function(){
                    util.removeLoading();
                },
                success:function(data){
                   //console.log(JSON.stringify(data));
                    let errors = '';
                    if(data&&data.isValid){
                         if(data.data.isValid){
                            state.bizQueryBatchData= data.data;
                         }else{
                            errors=data.data.errors;
                            state.bizQueryBatchData={};
                         }
                    }else{
                        errors = data.errors;
                        state.bizQueryBatchData={};
                    }
                    if(errors != '' &&　showErrorMsg){
                        if(errors.length>0){
                          let errorMsg = "";
                          let alertError = false;
                          for(let i= 0;i<errors.length;i++){
                            if(errors[i].checkType == null||errors[i].checkType=='0'||errors[i].checkType == 'null'){
                              alertError = true;
                              let error = errors[i];
                              errorMsg +=error.errorMsg;
                            }
                          }
                          if(alertError){
                             Notification(util.eleErrorJson(errorMsg));
                          }
                        }else{
                          Notification(util.eleErrorJson('单据操作异常'));
                        }
                    }

                }
        },func)

    },

    //5.0 报表模块初始化data
    StdQueryConfig_INIT(state,moduleID,func){
        util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQueryConfig",
                dataType:"json",
                data:{
                    moduleID:moduleID,
                },
                success:function(data){
                    let errors = '';
                    if(data&&data.isValid){
                         if(data.data.isValid){
                            state.stdQueryConfigData= data.data;
                         }else{
                            Notification(util.eleErrorJson('模块配置查询异常'));
                            state.stdQueryConfigData={};
                         }
                    }else{
                         Notification(util.eleErrorJson('模块配置请求异常'));
                        state.stdQueryConfigData={};
                    }
                },
                error(e){
                    Notification(util.eleErrorJson('模块配置请求出错~'));
                }
        },func)
    },

    //5.2 报表查询条件
    STDQueryChart_DATA(state,params){
        state.reportQueryParamsData = params;
    },
    //6.0  设置登陆平台 对象
    SYSTEMINFO_INIT(state,params){
        let systemInfoJson = JSON.parse(window.localStorage.getItem(systemInfo));
        if(systemInfoJson != null && Object.keys(systemInfoJson).length>0){
            state.systemInfo = systemInfoJson;
        }else{
           state.systemInfo = params;
        }
     },
    //6.1   为elTable 设置操作按钮对象
     OPERATION_BUTTON_INIT(state,params){
        let operationInitData = [];
        if(params){
            params.map(function(x){
                 if(x == 'details'){
                     let  json = {
                         name:'查看',
                         emitKey:'on-viewdetails'
                     }
                     operationInitData.push(json);
                  }
                  if(x == 'rollback'){
                      let  json = {
                        name:'还原',
                        emitKey:'on-rollback'
                      }
                    operationInitData.push(json);
                  }
                  if(x == 'delete'){
                    let  json = {
                      name:'删除',
                      emitKey:'on-delete'
                    }
                    operationInitData.push(json);
                  }
            });
        }
        state.operationButton = operationInitData;
     },
     //6.2 清除elTable 的操作按钮对象
      OPERATION_BUTTON_RESERT(state){
         console.log('重置按钮对象')
        state.operationButton = [];
      },
      //6.3  为smallQuery 查询 带入预设的查询参数
     SmallQuery_Add_Param_FromParent(state,params){
           state.smallQueryAddParamByParent=params; //父组件为smallQuery查询时预设置的查询参数
     },
  //6.4 清除  查询预设的查询参数 和要求隐藏的列表
     SmallQuery_Clear_Params_And_Hide(state){
        state.SmallQueryHideParam = {};
       state.smallQueryAddParamByParent= {};
     },

  //6.5 设置 B00005 模块  根据条码找出的基础资料信息，供第二步 匹配
      Set_MainBarGode_Goods_Data(state,data){
          state.mainBarCodeGoodsData = data;
       },
  //6.6 清除 B00005 模块  根据条码找出的基础资料信息
       Clear_MainBarGode_Goods_Data(state){
         state.mainBarCodeGoodsData = {};
       },
  //6.7 获取B0005模块商品分类
      GETGOODSCATEGORY_DATA(state, func){
        let _self=this;
            util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQuery",
                data:{
                    queryName: 'CategoryChoose'
                },
                dataType:"json",
                success(data) {
                    if(data.isValid){
                        if(data.data.isValid){
                            if(data.data.dataList.length>0){
                                    state.goodsCategory=data;
                            }else{
                                Notification(util.eleInfoJson('暂未查询到数据'));
                                state.goodsCategory = {};
                            }
                        }else{
                            var errors = data.data.errors;
                            if(errors.length>0){
                                var errorMsg = "";
                                for(var i= 0;i<errors.length;i++){
                                    var error = errors[i];
                                    errorMsg +=error.errorMsg;
                                }
                                Notification(util.eleErrorJson(errorMsg));
                            }else{
                               Notification(util.eleErrorJson('查询结果异常'));
                            }
                        }
                    }else{
                        Notification(util.eleErrorJson('查询结果请求异常'));
                    }

                },
                error(){
                    Notification(util.eleErrorJson('查询结果请求出错'));
                }
            },func)
      },
      //6.8 重置 pageObject
      PAGEOBJECT_RESERT(state){
        state.pageObject={
           currentPage:1,
            pageSize:10
        }
      },
    //6.9 B0005模块根据条码获取图片
    GETGOODSPICTURE_DATA(state,barcode,func){
        let _self=this;
            util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQuery",
                data:{
                    queryName: 'GoodsPicChoose',
                    Barcode: barcode
                },
                dataType:"json",
                success(data) {
                    if(data.isValid){
                        if(data.data.isValid){
                            if(data.data.dataList.length>0){
                                state.goodsPicture=data;
                            }else{
                                state.goodsPicture = {};
                            }
                        }else{
                            var errors = data.data.errors;
                            if(errors.length>0){
                                var errorMsg = "";
                                for(var i= 0;i<errors.length;i++){
                                    var error = errors[i];
                                    errorMsg +=error.errorMsg;
                                }
                                Notification(util.eleErrorJson(errorMsg));
                            }else{
                               Notification(util.eleErrorJson('查询结果异常'));
                            }
                        }
                    }else{
                        Notification(util.eleErrorJson('查询结果请求异常'));
                    }

                },
                error(){
                    Notification(util.eleErrorJson('查询结果请求出错'));
                }
            },func)
    },

    //7.0 a00003 模块  获取系统参数信息
    GETSYSPARAMSINFO_DATA(state,func){
        let _self=this;
            util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQuery",
                data:{
                    queryName: 'SystemCtrls',
                },
                dataType:"json",
                success(data) {
                    if(data.isValid){
                        if(data.data.isValid){
                            if(data.data.dataList.length>0){
                                state.sysParamsInfo=data;
                            }else{
                                state.sysParamsInfo = {};
                            }
                        }else{
                            var errors = data.data.errors;
                            if(errors.length>0){
                                var errorMsg = "";
                                for(var i= 0;i<errors.length;i++){
                                    var error = errors[i];
                                    errorMsg +=error.errorMsg;
                                }
                                Notification(util.eleErrorJson(errorMsg));
                            }else{
                               Notification(util.eleErrorJson('查询结果异常'));
                            }
                        }
                    }else{
                        Notification(util.eleErrorJson('查询结果请求异常'));
                    }

                },
                error(){
                    Notification(util.eleErrorJson('查询结果请求出错'));
                }
            },func)
    },
    GETTABLE_DATA(state,queryparams, func){
        let self=this;
            util.myAjax({
                url:util.getUrl()+"/StdQuery/StdQuery",
                data:queryparams,
                dataType:"json",
                success(data) {
                    if(data.isValid){
                        if(data.data.isValid){
                            if(data.data.dataList.length>0){
                                state.tableData = data;
                            }else{
                                state.tableData = {};
                            }
                        }else{
                            var errors = data.data.errors;
                            if(errors.length>0){
                                var errorMsg = "";
                                for(var i= 0;i<errors.length;i++){
                                    var error = errors[i];
                                    errorMsg +=error.errorMsg;
                                }
                                Notification(util.eleErrorJson(errorMsg));
                            }else{
                               Notification(util.eleErrorJson('查询结果异常'));
                            }
                        }
                    }else{
                        Notification(util.eleErrorJson('查询结果请求异常'));
                    }

                },
                error(){
                    Notification(util.eleErrorJson('查询结果请求出错'));
                }
            },func)
    },

};

export default new Vuex.Store({
    state,
    mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js